import {OpenapiPostV1CryptoInternalPayinSessionUpdateInputWalletParamsTypeEnum} from '@stripe-internal/data-v1/schema/types';
import {WalletProvider} from 'src/types';
import {absurd} from 'src/utils/absurd';

export const convertWalletTypeToApiType = (
  type: WalletProvider,
): OpenapiPostV1CryptoInternalPayinSessionUpdateInputWalletParamsTypeEnum => {
  switch (type) {
    case 'MetaMask':
      return 'metamask';
    case 'Phantom':
      return 'phantom';
    case 'Coinbase Wallet':
      return 'coinbase_wallet';
    case 'WalletConnect':
      return 'wallet_connect';
    default:
      return absurd(type);
  }
};
